<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0">
    <div>
      <slot name="header" />
    </div>

    <div class="w-96 sm:w-full max-w-md mt-6 bg-white shadow-md rounded-lg">
      <slot />
    </div>

    <div class="mt-10">
      <slot name="logo" />
    </div>
  </div>
</template>
